'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAttachments = undefined;

var _reduxActions = require('redux-actions');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var clearAttachments = exports.clearAttachments = (0, _reduxActions.createAction)(_fileUploadsActionTypes.CLEAR_ATTACHMENTS, function (threadId) {
  return {
    threadId: threadId
  };
});


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/clearAttachments.js
// module id = 648
// module chunks = 2 3